// Deprecated

import { Box, CircularProgress, Container, Typography } from '@mui/material';
import { useEventTodo } from '../context';
import TodoPage from './TodoPage';
import { db } from '../instant';
import NoEventError from './NoEventError';
import { EVENT_TAB_SCROLL_END_GAP_PX } from 'src/spacing';
import { id } from '@instantdb/core';

interface Props {
    eventId: string;
}

export default function EventTodo(props: Props) {
    const { todo, todoIsLoading, todoError } = useEventTodo(props.eventId);

    if (todoIsLoading) {
        return (
            <Box display="flex" justifyContent="center" padding={4}>
                <CircularProgress />
            </Box>
        );
    }

    if (todoError) {
        return <Typography color="error">Error loading todo details: {todoError.message}</Typography>;
    }

    if (!todo) {
        return <NoEventError eventId={props.eventId} />;
    }

    const createTodo = (todoData: { todoTypeId: string; mapPinId?: string; areaCoordinates?: string; notes?: string }) => {
        db.transact(
            db.tx.todos[id()]
                .update({
                    notes: todoData.notes || '',
                    areaCoordinates: todoData.areaCoordinates,
                    completed: false,
                    created_at: new Date(),
                    completed_at: new Date(0),
                })
                .link({
                    event: props.eventId,
                    todoType: todoData.todoTypeId,
                    ...(todoData.mapPinId ? { mapPin: todoData.mapPinId } : {}),
                })
        ).catch((err: Error) => console.error('error creating todo: ', err));
    };

    const completeTodo = (todoId: string) => {
        const currentTodo = Array.isArray(todo) ? todo.find(t => t.id === todoId) : null;
        const newCompletedState = currentTodo ? !currentTodo.completed : true;

        db.transact(
            db.tx.todos[todoId].update({
                completed: newCompletedState,
                completed_at: newCompletedState ? new Date() : new Date(0),
            })
        ).catch((err: Error) => console.error('error updating todo: ', err));
    };

    const editTodoNote = (todoId: string, note: string) => {
        db.transact(
            db.tx.todos[todoId].update({
                notes: note,
            })
        ).catch((err: Error) => console.error('error updating todo: ', err));
    };

    const deleteTodo = (todoId: string) => {
        db.transact(db.tx.todos[todoId].delete());
    };

    return (
        <Container
            maxWidth="sm"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                paddingBottom: `${EVENT_TAB_SCROLL_END_GAP_PX}px`,
                alignItems: 'center',
                height: '100%',
            }}
        >
            <TodoPage
                eventId={props.eventId}
                value={todo}
                create={createTodo}
                complete={completeTodo}
                remove={deleteTodo}
                editNote={editTodoNote}
            />
        </Container>
    );
}
